import React from "react";
import { formatDateAndHour } from "helpers/Parsers";
import { Tooltip } from "react-tippy";
import styles from "./MainApp.organisms.Product.Table.TableItem.module.scss";
import i18n from "i18n";

const tooltipStyle = {
  background: "#FFFFFF",
  boxShadow: "0px 3px 6px #00000029",
  height: "45px",
  padding: "0 15px",
  color: "#494F66",
  fontFamily: "Roboto-Light",
  fontSize: "18px",
  borderRadius: "15px",
  display: "flex",
  alignItems: "center",
};

export class AuditTableItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSelected: this.props.isSelected,
    };
  }

  handleSelect = () => {
    this.props.handleSelect(this.props.audit.id);
  };

  render() {
    const { audit, handleClick } = this.props;

    const { date, hour } = formatDateAndHour(audit.date);

    return (
      <div className={styles["table-item-container"]} data-automation-id="audit-item">
        <div className={styles["table-item-date"]} data-audit-id={audit.id} onClick={handleClick}>
          {date}
        </div>
        <div className={styles["table-item-time"]} data-audit-id={audit.id} onClick={handleClick}>
          {hour}
        </div>
        <div className={styles["table-item-location"]} data-audit-id={audit.id} onClick={handleClick}>
          <Tooltip html={<div style={tooltipStyle}>{audit.path_name}</div>} title={audit.path_name} followCursor={true} position="left" offset={25}>
            <p>{audit.path_name}</p>
          </Tooltip>
        </div>

        <div className={styles["table-item-user"]} data-audit-id={audit.id} onClick={handleClick}>
          {audit.user_name}
        </div>

        <div className={styles["table-item-status"]} data-audit-id={audit.id} onClick={handleClick}>
          <span className={`${styles["status-pill"]} ${audit.status ? styles["status-true"] : styles["status-false"]}`}>
            {audit.status ? i18n.t("complete") : i18n.t("incomplete")}
          </span>
        </div>

        <div className={styles["table-item-modified"]} data-audit-id={audit.id} onClick={handleClick}>
          <span className={`${styles["modified-pill"]} ${audit.modified ? styles["modified-true"] : styles["modified-false"]}`}>
            {audit.modified === true ? i18n.t("modified") : i18n.t("no.modified")}
          </span>
        </div>

        <div className={styles["table-item-button"]} data-automation-id="select-audit" data-audit-id={audit.id} onClick={handleClick}>
          <i className={`icon-chevron-derecha ${styles["table-item-button-icon"]}`} />
        </div>
      </div>
    );
  }
}

AuditTableItem.propTypes = {};

export default AuditTableItem;
